"use strict";
exports.__esModule = true;
exports.ensureArray = void 0;
var ramda_1 = require("ramda");
exports.ensureArray = ramda_1.when(Boolean, function (data) {
    return ramda_1.is(Array, data) ? data : [data];
});
//# sourceMappingURL=ensureArray.js.map